import { Stack } from 'react-bootstrap';
import './style.scss';

const Login = () => {
  return (
    <Stack gap={2} className="justify-content-center align-items-center text-center">
      <h4 className="text-primary mb-3">Asistente virtual fuera de servicio</h4>
      <p className="mb-0">
        Nuestro asistente virtual finalizó su periodo de servicio. Agradecemos a quienes lo
        utilizaron durante su disponibilidad, activo hasta el{' '}
        <strong>25 de febrero del 2026</strong>.
      </p>
    </Stack>
  );
};

export default Login;

// import { AxiosError } from 'axios';
// import { FormEvent, useState } from 'react';
// import { Col, Row, Stack, Button, Form } from 'react-bootstrap';
// import { Link, useLocation, useNavigate } from 'react-router-dom';
// import { ILocationState } from '../../commons/interfaces/auth.interface';
// import CustomFormInput from '../../components/CustomFormInput';
// import Paper from '../../components/Paper';
// import useAPIError from '../../hooks/apiError.context';
// import useAuth from '../../hooks/auth.hook';
// import './style.scss';

// const Login = () => {
//   const auth = useAuth();
//   const location = useLocation();
//   const navigate = useNavigate();
//   const [validated, setValidated] = useState(false);
//   const [email, setEmail] = useState('');
//   const [password, setPassword] = useState('');
//   const { addError } = useAPIError();

//   const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
//     event.preventDefault();

//     const form = event.currentTarget;
//     const isFormValid = form.checkValidity();

//     if (isFormValid) {
//       try {
//         await auth.signin({ email, password });
//         const from = (location.state as ILocationState)?.from?.pathname || '/';
//         navigate(from, { replace: true });
//       } catch (err) {
//         if (err instanceof AxiosError) {
//           const { response } = err;
//           addError(response?.data.message, 'danger');
//         }
//       }
//     }

//     setValidated(true);
//   };

//   return (
//     <Stack gap={3}>
//       <Paper className="auth-header bg-primary text-white">
//         <span>
//           Bienvenidos a la <br />
//           Plataforma de atención al cliente
//         </span>
//       </Paper>
//       <Form noValidate validated={validated} onSubmit={handleSubmit}>
//         <CustomFormInput
//           type="email"
//           placeholder="Correo electrónico"
//           feedback="Ingrese su correo electrónico."
//           value={email}
//           onChange={(ev) => setEmail(ev.target.value)}
//           required
//         />
//         <CustomFormInput
//           type="password"
//           placeholder="Contraseña"
//           feedback="Ingrese su contraseña."
//           minLength={8}
//           value={password}
//           onChange={(ev) => setPassword(ev.target.value)}
//           required
//         />
//         <div className="forgot-password">
//           <Link to="./../password-recovery">¿Olvidaste tu contraseña?</Link>
//         </div>
//         <Row className="justify-content-around">
//           <Col className="d-flex align-items-center" xs={8}>
//             <Button type="submit" className="w-100">
//               Iniciar sesión
//             </Button>
//           </Col>
//         </Row>
//       </Form>
//     </Stack>
//   );
// };
// export default Login;
